<template>
	<div>
		<TableView :col="columns" :getData="getData"/>  
    <b-modal ref="view-deal-out" :title="'View Deal'" size="xl" hide-footer>
      <AddDealForm :rows="rowData" />
    </b-modal>         
	</div>
</template>
<script>
import common from '@/assets/js/common.js';

export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
    AddDealForm: () => import('@/components/Accounts/AddDealForm')
  },
  mixins: [common],
  props: ['row', 'nested'],
  data(){
  	return {
      rowData:{},
      columns: (() => {
        const cols = [
          { title: 'Approve', tdComp: 'tradeApprove', visible: this.can_access('deal_approve','view') },
          { title: 'Contract Note', field: 'contract_note', thComp: 'FilterTh', tdStyle: {'text-decoration':'underline dashed'},sortable: true, tdOnClick:this.ShowDealDetail},
          /* { title: 'Ticket Number', field: 'ticket_number' }, */
          { title: 'Acc. No.', field: 'account_number', thComp: 'FilterTh', tdStyle: {padding: this.can_access('deal','modify')?"":"0.8rem !important"}},
          /* { title: 'Ticker', field: 'stock', 'nested': 'tidm', thComp: 'FilterTh'},
          { title: 'Issuer Name', field: 'stock', 'nested': 'issuer_name', thComp: 'FilterTh'},
          { title: 'Type', field: 'type', thComp: 'FilterTh'}, */
          { title: 'Quantity', field: 'total_quantity',tdComp: 'Number', 'floatLength': 2},
          { title: 'Trade Price', field: 'trade_price', sortable: true , tdComp: 'Number'},
          { title: 'Trade Value', field: 'trade_value', sortable: true, tdComp: 'Number', 'floatLength': 2},
          { title: 'Cost Price', field: 'cost_price', tdComp: 'Number' },
          { title: 'Total Charges', field: 'total_other_charges', tdComp: 'Number' , 'floatLength': 2},
          { title: 'Cosideration', field: 'total_consideration', tdComp: 'Number' , 'floatLength': 2},
          /* { title: 'Trade Date', field: 'trade_date', sortable: true }, */
          { title: 'Operation', tdComp: 'tradeOpt', visible: 'true' }
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  methods: {
    ShowDealDetail(item){
      //console.log(item)
      item.action = 'view'
      this.rowData = item;
      this.$refs['view-deal-out'].show()
    },
    async getData(query, filter) {
      var { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      filter['ticket_number'] = this.row.ticket_number;
      //filter['account_number'] = this.row.account_number;
      this.columns.forEach(col => {
        if (query[col.field]) {
          filter[col.field] = query[col.field];
        }else if(typeof filter[col.field] != 'undefined' && ['ticket_number'].indexOf(col.field)<0){
          delete filter[col.field];
        }
      });
      console.log('wc', this.row.with_cancelled)
      let uri = 'trade_list?with_cancelled='+this.row.with_cancelled+'&noGrouping=1&limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
      return await this.call_axios(uri);
    }
  }
}
</script>